// extracted by mini-css-extract-plugin
export default {"backgroundTransparent":"YuQX5hQ4DdLGb9k43ViQ"};